import apiClient from '../lib/axios';

export interface PharmacyChain {
  id: string;
  name: string;
  isActive: boolean;
}

export async function listPharmacyChains(): Promise<PharmacyChain[]> {
  const { data } = await apiClient.get<PharmacyChain[]>('/pharmacy-chains');
  return data;
}
